import React from 'react';
import { Button } from "react-bootstrap";

const Row = ({ id, date, partner, subid, partners, onRemove }) => {
    return (
        <tr>
            <td>{date}</td>
            <td>{partners[partner]}</td>
            <td>{subid}</td>
            <td>
                <Button bsStyle="danger" onClick={() => onRemove(id)}>Remove</Button>
            </td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/AdkPartnerBlock/components/Table/components/Row/index.js